import Image from "next/image";
import Link from "next/link";

export type OfferBannerVariant = "A" | "B" | "C";

type OfferBannerProps = {
  variant: OfferBannerVariant;
};

export const OfferBanner = ({ variant }: OfferBannerProps) => {
  const bannerSrc =
    variant === "A"
      ? "/banner1.webp"
      : variant === "B"
        ? "/banner2.webp"
        : "/banner3.webp";

  const bannerLinkClass =
    variant === "A"
      ? "absolute left-0 top-0 z-20 h-full"
      : "absolute inset-0 z-20";

  const bannerImageClass =
    variant === "A"
      ? "h-full w-auto animate-slide-in-left pointer-events-none select-none"
      : "h-full w-full object-cover pointer-events-none select-none";

  return (
    <Link href="/angebote" className={bannerLinkClass}>
      <Image
        src={bannerSrc}
        alt=""
        id="offer-banner"
        width={800}
        height={1200}
        className={bannerImageClass}
        priority
      />
    </Link>
  );
};
